import React, { createContext, useState } from 'react';

export const TelemetryDataContext = createContext();

export const TelemetryDataProvider = ({ children }) => {
  const [telemetryData, setTelemetryData] = useState({
    browserSessionId: "",
    footerFeedback : {

    },
    troubleshoot: {

    },
    userInfo: {

    }
  });

  return (
    <TelemetryDataContext.Provider value={{ telemetryData, setTelemetryData }}>
      {children}
    </TelemetryDataContext.Provider>
  );
};